import { render, staticRenderFns } from "./iconMedic.vue?vue&type=template&id=6c420233&"
import script from "./iconMedic.vue?vue&type=script&lang=js&"
export * from "./iconMedic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports